import { useEffect, useState } from 'react'
import { Country } from '../../domain/country'
import { AxiosCountryRepository } from '../../infrastructure/AxiosCountryRepository'
import { ListCountryUseCase } from '../../usecases/ListCountryUseCase'

const useCountry = () => {
    const [countries, setCountries] = useState<Country[]>([])
    const [isLoading, setIsLoading] = useState(false)
    const [error, setError] = useState<string | null>(null)

    useEffect(() => {
        const fetchCountries = async () => {
            try {
                setIsLoading(true)
                setError(null)

                const repository = new AxiosCountryRepository()
                const useCase = new ListCountryUseCase(repository)

                const result = await useCase.execute()
                setCountries(result)
            } catch (err) {
                setError(
                    err instanceof Error
                        ? err.message
                        : 'Error fetching countries'
                )
                setCountries([])
            } finally {
                setIsLoading(false)
            }
        }

        fetchCountries()
    }, [])

    return {
        countries,
        isLoading,
        error,
    }
}

export default useCountry
